import * as api from './api.json'
import * as blockchain from './blockchain.json'
import * as firebase from './firebase.json'
import * as house from './house.json'

export default { api, blockchain, firebase, house }